module.exports = __webpack_public_path__ + "img/brnn.2e920d4f.jpg";